import React, { PureComponent } from 'react';
import styled, { css } from 'react-emotion';
import {
    colors,
    fontSize,
    letterSpacing,
    lineHeight,
    mq,
    rWidth,
} from '../../../css';

import Partners from '../content/partners';
import Partner from './partner.component';

export default class Patners extends PureComponent {
    constructor() {
        super();
    }

    renderPartners() {
        return Partners.map(partner => {
            const { content, image, title } = partner;
            return (
                <Partner
                    key={partner.title}
                    {...{
                        content,
                        image,
                        title,
                    }}
                />
            );
        });
    }

    render() {
        return (
            <section className={s.wrapper} id="partners">
                <s.heading>
                    <h2>Partners</h2>
                </s.heading>
                <s.partners>{this.renderPartners()}</s.partners>
            </section>
        );
    }
}

const s = {};

s.wrapper = css`
    background: ${colors.white};
    width: 100%;
    ${mq({
        paddingLeft: [20, 60, 60, 30, rWidth(240 / 2), rWidth(240)],
        paddingRight: [20, 60, 60, 30, rWidth(240 / 2), rWidth(240)],
        paddingTop: [60, 60, 80, 80, 80, 120],
        paddingBottom: [60, 60, 80, 80, 80, 120],
    })};
`;

s.heading = styled.div`
    width: 100%;
    line-height: ${lineHeight(53, 45)};
    letter-spacing: ${letterSpacing(200)};
    h2 {
        color: ${colors.blue};
        margin: 0 0 1.5em;
    }
    ${mq({
        paddingRight: [20, 20, 20, 0],
        textAlign: ['right', 'right', 'right', 'left'],
        fontSize: [
            fontSize(20),
            fontSize(25),
            fontSize(25),
            fontSize(20),
            fontSize(30),
        ],
    })};
`;

s.partners = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-around;
    flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./src/components/sections/partners/partners.component.js